import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import { Dialog, useToggle, Radio } from "@genesis/ui-kit";
import { displayDateComaYear } from "../../../Shared/Utill/Utills";
import classes from "./checkboxdialog.module.scss";
import axios from "axios";
import { constants } from "../../../Shared/Url/Constants";
import Cookie from "js-cookie";
import { useSelector, useDispatch } from "react-redux";
import moment from 'moment';
import { messages } from "../../../Shared/Messages/ErrorMessages";
import { toUpperCaseString } from "../../../Shared/Utill/Utills";

const DailyPWHCheckboxDialog = (props) => {
  const urlDetails = useSelector((state) => state.url.urlData);
  const dialog = useToggle();
  const token = Cookie.get('X_TKN');
  const [value, setValue] = React.useState('Y');
  const [cutOffDate, setCutOffDate] = React.useState(props.cutOffDate);
  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};
  const personDetails = useSelector((state) => state.person.personData);

  useEffect(() => {
    dialog.show();
  }, []);

  const closeDialog = () => {
    dialog.hide();
    props.dismissDialog();
  };


  const confirmDialogClick = () => {
    if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
      setAlertOpen({
        open: true,
        severity: 'error',
        message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
      })
      return;
    }
    // Request Payload : {recordId : avlId, cutoffdate: control card futureend value01 from prop, isOverride : (value === '1' ? 'Y' : 'N') }
    copyFutureWeeksService();
  }
  const handleChange = (event) => {
    setValue(event.target.value);
  };

    //Fetch daily tiles data from API 
  const copyFutureWeeksService = () => {
    let reqCutoffDate = moment(cutOffDate).format('YYYY-MM-DD');

      // request Body
      let requestPayload = {
        "pwh_or_avl" : props.isDaily ? 'AVL' : 'PWH',
        "avlId" : props.data.avlId,
        "ctlCardEndDate" : reqCutoffDate,
        "overWriteOption" : value
        }

      console.log("payload API"+JSON.stringify(requestPayload)); 
      // Network request to copy future weeks data
      axios({
        url: `${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_COPY_FUTURE_WEEKS}`,
        method: "POST",
        data: requestPayload,
        headers:{
          'Content-Type': 'application/json',
          'Authorization':'Bearer ' + token,
        },    
      })
      .then((res) => {
          // check status code handle success/failure
          let resp = res.data;
           if (res.status == 200) {
            props.chkSuccessCallback(props.isDaily,'Record saved successfully.')
           }else{
            props.chkFailCallback(props.isDaily,'Something went wrong.');
           }
         //console.log("Copy Future Weeks Resp: " + res.data);
      })
      .catch((err) => {
        let message = err.message;
        //let respMsg = err.;
        //console.log("Copy Future Weeks Resp: " + JSON.stringify(err));
        if(err.message === 'Network Error') {
        } 
        props.chkFailCallback(props.isDaily,err.response.data.message);
      });   
    }

  return (
    <Box>
    <Dialog
      open={dialog.open}
      title={props.isDaily ? "Availability For Future Weeks" : "Preferences For Future Weeks"}
      onClose={closeDialog}
      actions={
        <>
          <Button color={"secondary"} onClick={closeDialog}>
            Cancel
          </Button>
          <Button onClick={confirmDialogClick}>Confirm</Button>
        </>
      }
    >
      <Typography >
        This selection impacts any availability inputs that you have made for
        future weeks. Please confirm how you would like to proceed.
      </Typography>
      <FormControl margin="normal" >
        <RadioGroup
         defaultValue="Y" 
         value={value}
         onChange={handleChange}
         >
          <div className={classes.radiobtnst}>
          <FormControlLabel value="Y" control={<Radio className={classes.radiobtnst} />} label={"Delete all future weeks and replace with these selections through "+ displayDateComaYear(new Date(cutOffDate))} />
          {/* <FormControlLabel value="N" control={<Radio className={classes.radiobtnst}/>} label={"Update only unedited weeks through "+ displayDateComaYear(new Date(cutOffDate))} /> */}
          </div>
        </RadioGroup>
      </FormControl>
    </Dialog>
    </Box>
  );
};

export default DailyPWHCheckboxDialog;
